import { gsap } from "gsap";
import { Container, Sprite } from "pixi.js";

export class GSAPScreenShake {
    private static activeTweens = new Map<Container | Sprite, gsap.core.Tween>();
    private static originalPositions = new Map<Container | Sprite, { lx: number, ly: number }>();

    public static shake2(
        targets: (Container | Sprite)[],
        durationMs: number = 3000,
        magnitude: number = 20
    ) {


        const tl = gsap.timeline();

        targets.forEach(target => {

            const startX = target.x;
            const startY = target.y;

            const tween = gsap.to(target, {
                duration: 0.05,
                repeat: Math.floor(durationMs / 50),

                x: `random(${startX - magnitude}, ${startX + magnitude})`,
                y: `random(${startY - magnitude}, ${startY + magnitude})`,
                repeatRefresh: true,
                yoyo: true,
                ease: "power1.inOut",
                onComplete: () => {
                    gsap.killTweensOf(target);
                    target.x = startX;
                    target.y = startY;
                }
            });

            tl.add(tween, 0);
        });
    }

    public static shake(
        targets: (Container | Sprite)[],
        durationMs: number = 3000,
        magnitude: number = 20,
        slowdownStartMs: number = 1000
    ) {
        // durationMs = isSuperQuickBtnOnGlobal ? durationMs : Math.floor(durationMs / 2);
        // slowdownStartMs = isSuperQuickBtnOnGlobal ? slowdownStartMs : Math.floor(slowdownStartMs / 2);
        const durationSec = durationMs / 1000;
        const slowdownStartSec = slowdownStartMs / 1000;

        targets.forEach(target => {
            const startX = target.x;
            const startY = target.y;

            const effect = { currentMag: magnitude };

            gsap.to(target, {
                duration: 0.05,
                repeat: -1,
                x: () => startX + (Math.random() * 2 - 1) * effect.currentMag,
                y: () => startY + (Math.random() * 2 - 1) * effect.currentMag,
                repeatRefresh: true,
                ease: "none"
            });

            gsap.to(effect, {
                currentMag: 0,
                duration: durationSec - slowdownStartSec,
                delay: slowdownStartSec,
                ease: "power2.out",
                onUpdate: () => {

                },
                onComplete: () => {
                    gsap.killTweensOf(target);
                    gsap.killTweensOf(effect);
                    target.x = startX;
                    target.y = startY;
                }
            });
        });
    }

    public static stop(target?: Container | Sprite): void {
        if (target) {
            this.resetTarget(target);
        } else {
            this.activeTweens.forEach((_, t) => this.resetTarget(t));
        }
    }

    private static resetTarget(target: Container | Sprite): void {
        if (this.activeTweens.has(target)) {
            this.activeTweens.get(target)?.kill();
            this.activeTweens.delete(target);
        }

        const orig = this.originalPositions.get(target);
        if (orig) {
            target.position.set(orig.lx, orig.ly);
            this.originalPositions.delete(target);
        }
    }
}
